import { authEvents } from '@/shared/lib/auth-events';
import { disconnectEchoSingleton } from '@/shared/api/websocket';

/**
 * WebSocket authentication event handlers
 * Decouples WebSocket from auth store to avoid circular dependencies
 */
export class WebSocketAuthEvents {
  /**
   * Handle user login - connect WebSocket
   */
  static onLogin(userId: string, token: string) {
    authEvents.emitWebSocketConnect(userId, token);
  }

  /**
   * Handle user logout - disconnect WebSocket and clear auth cache
   */
  static onLogout() {
    disconnectEchoSingleton();

    authEvents.emitWebSocketDisconnect();
  }

  /**
   * Handle auth initialization
   */
  static onAuthInitialized(userId: string | null, token: string | null) {
    if (userId && token) {
      authEvents.emitWebSocketConnect(userId, token);
    } else {
      authEvents.emitWebSocketDisconnect();
    }
  }
}
